import { render } from "./isfikirCard.vue?vue&type=template&id=51a2d364"
import script from "./isfikirCard.vue?vue&type=script&lang=js"
export * from "./isfikirCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__